// extracted by mini-css-extract-plugin
export var growableInput = "_98-0";
export var tagContainer = "_98-2";
export var textInput = "_98-1";